<script lang="ts">
  interface Props {
    text: string;
    variant?: "success" | "error" | "neutral";
    class?: string;
    size?: "xs" | "sm" | "md" | "lg";
  }

  let { text, variant = "success", class: className = "", size = "sm" }: Props = $props();
</script>

<div
  class="flex w-fit items-center justify-center rounded-[4px] px-1 font-mono leading-none text-nowrap uppercase {className}"
  class:bg-success-subtle-bg={variant === "success"}
  class:text-pri-800={variant === "success"}
  class:bg-error-subtle-bg={variant === "error"}
  class:text-sec-800={variant === "error"}
  class:bg-mono-100={variant === "neutral"}
  class:text-mono-700={variant === "neutral"}
  class:text-[11px]={size === "sm"}
  class:text-sm={size === "md"}
  class:text-base={size === "lg"}
  class:text-[10px]={size === "xs"}
  class:py-[0.5px]={size === "xs"}
  class:py-1={size !== "xs"}
  class:h-5={size === "xs"}
>
  <span class="translate-y-[0.5px]">{text}</span>
</div>
